<div class="global-overlay-page">
    <div class="topbar">

        <div class="menu">
            <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">

                <mat-form-field appearance="outline" class="custom-select-padding" style="width: 300px;">
                    <mat-label>Select Report</mat-label>
                    <mat-select formControlName="reportId" (selectionChange)="onSubmit()">
                        @for (report of reports; track report.id) {
                        <mat-option [value]="report.id">{{report.name}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="custom-select-padding"
                    style="width: 200px; margin-left: 10px;">
                    <mat-label>Select academic year</mat-label>
                    <mat-select (selectionChange)="selectAcademicYear($event.value)">
                        <mat-option [value]="null">None</mat-option>
                        @for (year of academicYears; track year) {
                        <mat-option [value]="year.formatted_year">{{year.formatted_year}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="custom-select-padding"
                    style="width: 200px; margin-left: 10px;">
                    <mat-label>From date</mat-label>
                    <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" (dateChange)="onSubmit()"
                        (blur)="onSubmit()">
                    <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #fromPicker></mat-datepicker>
                    @if (submitted && f.fromDate.errors?.date) {
                    <mat-error>Valid Date Required</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline" class="custom-select-padding"
                    style="width: 200px; margin-left: 10px;">
                    <mat-label>To date</mat-label>
                    <input matInput [matDatepicker]="toPicker" formControlName="toDate" (dateChange)="onSubmit()"
                        (blur)="onSubmit()">
                    <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                    <mat-datepicker #toPicker></mat-datepicker>
                    @if (submitted && f.toDate.errors?.date) {
                    <mat-error>Valid Date Required</mat-error>
                    }
                </mat-form-field>
            </form>

        </div>

        <div class="toolbar">
            <a (click)="newReport()">New Report</a>
            @if (searchForm.get('reportId').value) {
            <a (click)="editReport()">Edit Report</a>
            }
            <a (click)="downloadExcel()">
                Download Excel
            </a>
        </div>



    </div>

    <mat-table #table [dataSource]="loading ? [] : dataSource" matSort>

        @for (col of columnNames; track col.id) {
        <ng-container [matColumnDef]="col.id">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.value }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element[col.id] }}</mat-cell>
        </ng-container>
        }

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    @if (loading) {
    <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
            @for (weight of row; track $index) {
            <div class="skeleton-bar" [style.flex-grow]="weight"></div>
            }
        </div>
        }
    </div>
    }

    @if (!loading && (!dataSource?.data || dataSource.data.length == 0)) {
    <div style="padding: 20px; text-align: center; color: #666; font-style: italic;">
        No data available
    </div>
    }

</div>